import { BrowserRouter, Redirect, Route, Switch } from 'react-router-dom'
import * as firebase from 'firebase'
import * as React from 'react'

import Login from './Login'
import Logout from './Logout'
import RemoteControl from './RemoteControl'
import Tracking from './Tracking'
import Type from './Type'

interface State {
  userID?: string
}

export default class App extends React.Component<{}, State> {
  constructor(props: {}) {
    super(props)

    this.state = { userID: undefined }
    firebase.auth().onAuthStateChanged(user => this.setState({ userID: user ? user.uid : undefined }))
  }

  render() {
    return (
      <BrowserRouter>
        <React.Fragment>
          <Route component={Tracking} />

          <RemoteControl />

          <Switch>
            <Route
              path="/login"
              exact={true}
              render={() => this.state.userID ? <Redirect to="/" /> : <Login />}
            />

            <Route
              path="/logout"
              exact={true}
              component={Logout}
            />

            <Route
              path="/norotate"
              render={() => <Type rotate={false} userID={this.state.userID} />}
            />

            <Route
              path="/"
              render={() => <Type rotate={true} userID={this.state.userID} />}
            />
          </Switch>
        </React.Fragment>
      </BrowserRouter>
    )
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/App.tsx